// UI constants and color mappings

export const STATUS_BADGE_MAP = {
  Paid: 'bg-emerald-400/15 text-emerald-300 border-emerald-400/30',
  'Partial Paid': 'bg-blue-400/15 text-blue-300 border-blue-400/30',
  'DP Paid': 'bg-cyan-400/15 text-cyan-300 border-cyan-400/30',
  Unpaid: 'bg-slate-400/10 text-slate-200 border-slate-400/25',
  'Invoice Sent': 'bg-blue-400/15 text-blue-300 border-blue-400/30',
  'Due Today': 'bg-orange-400/15 text-orange-300 border-orange-400/30',
  Overdue: 'bg-red-400/15 text-red-300 border-red-400/30',
  Current: 'bg-slate-400/10 text-slate-200 border-slate-400/25',
  '1-7 Days': 'bg-orange-400/15 text-orange-300 border-orange-400/30',
  '8-14 Days': 'bg-orange-500/15 text-orange-300 border-orange-500/30',
  '15-30 Days': 'bg-amber-500/15 text-amber-300 border-amber-500/30',
  '31-60 Days': 'bg-amber-600/15 text-amber-300 border-amber-600/30',
  '60+ Days': 'bg-rose-500/15 text-rose-300 border-rose-500/30',
  Dispute: 'bg-violet-400/15 text-violet-300 border-violet-400/30',
  'Bad Debt': 'bg-zinc-900/60 text-zinc-200 border-red-900/40',
  Approved: 'bg-emerald-400/15 text-emerald-300 border-emerald-400/30',
  Sent: 'bg-blue-400/15 text-blue-300 border-blue-400/30',
  Draft: 'bg-slate-400/10 text-slate-200 border-slate-400/25',
  Rejected: 'bg-red-400/15 text-red-300 border-red-400/30',
  Expired: 'bg-orange-400/15 text-orange-300 border-orange-400/30',
  Cancelled: 'bg-zinc-500/15 text-zinc-300 border-zinc-500/30',
  'Lunas - Menunggu Bukti Potong': 'bg-teal-400/15 text-teal-300 border-teal-400/30',
};

export const STATUS_LABEL_ID = {
  Draft: 'Draft',
  Sent: 'Terkirim',
  Approved: 'Disetujui',
  Rejected: 'Ditolak',
  Expired: 'Kadaluarsa',
  Paid: 'Lunas',
  'Partial Paid': 'Dibayar Sebagian',
  'DP Paid': 'DP Dibayar',
  Unpaid: 'Belum Dibayar',
  'Invoice Sent': 'Invoice Terkirim',
  Overdue: 'Lewat Tempo',
  'Due Today': 'Jatuh Hari Ini',
  Current: 'Belum Jatuh Tempo',
  Cancelled: 'Dibatalkan',
  Dispute: 'Dispute',
  'Bad Debt': 'Bad Debt',
  'Lunas - Menunggu Bukti Potong': 'Lunas - Menunggu Bukti Potong',
};

export const MENU_LABEL_ID = {
  dashboard: 'Dashboard',
  clients: 'Client',
  products: 'Produk / Layanan',
  packages: 'Paket',
  quotations: 'Penawaran',
  invoices: 'Invoice',
  payments: 'Pembayaran',
  receivables: 'Piutang',
  followups: 'Follow-Up',
  reports: 'Laporan',
  importexport: 'Import / Export',
  settings: 'Pengaturan',
};

export const ROLE_LABEL_ID = {
  Owner: 'Owner',
  Accounting: 'Accounting',
  Admin: 'Admin',
  Marketing: 'Marketing',
  Viewer: 'Viewer',
};

export const CHANNEL_LABEL_ID = {
  WhatsApp: 'WhatsApp',
  Call: 'Telepon',
  Email: 'Email',
  Meeting: 'Pertemuan',
  Other: 'Lainnya',
};

export const PAYMENT_METHOD_LABEL_ID = {
  'Bank Transfer': 'Transfer Bank',
  Cash: 'Tunai',
  QRIS: 'QRIS',
  'E-Wallet': 'E-Wallet',
  Other: 'Lainnya',
};

// Role-based permissions (matches backend)
export const PERMISSIONS = {
  canManageUsers: (role) => role === 'Owner',
  canDeleteFinancial: (role) => ['Owner', 'Accounting'].includes(role),
  canManagePayments: (role) => ['Owner', 'Accounting', 'Admin'].includes(role),
  canCreateQuotation: (role) => ['Owner', 'Accounting', 'Admin', 'Marketing'].includes(role),
  canCreateInvoice: (role) => ['Owner', 'Accounting', 'Admin'].includes(role),
  canEdit: (role) => role !== 'Viewer',
  canImportExport: (role) => ['Owner', 'Accounting'].includes(role),
};

export const MENU_VISIBILITY = {
  dashboard: ['Owner', 'Accounting', 'Admin', 'Marketing', 'Viewer'],
  clients: ['Owner', 'Accounting', 'Admin', 'Marketing', 'Viewer'],
  products: ['Owner', 'Accounting', 'Admin', 'Marketing', 'Viewer'],
  packages: ['Owner', 'Accounting', 'Admin', 'Marketing', 'Viewer'],
  quotations: ['Owner', 'Accounting', 'Admin', 'Marketing', 'Viewer'],
  invoices: ['Owner', 'Accounting', 'Admin', 'Marketing', 'Viewer'],
  payments: ['Owner', 'Accounting', 'Admin', 'Viewer'],
  receivables: ['Owner', 'Accounting', 'Admin', 'Marketing', 'Viewer'],
  followups: ['Owner', 'Accounting', 'Admin', 'Marketing', 'Viewer'],
  reports: ['Owner', 'Accounting', 'Admin', 'Marketing', 'Viewer'],
  importexport: ['Owner', 'Accounting'],
  settings: ['Owner', 'Accounting'],
};
